import ResourcesBase from 'modules/digital-product/resources/components/resources-base'
import { useDigitalResourceContent } from 'modules/digital-product/resources/hooks/use-digital-resource-content'
import { DigitalResourceType } from 'modules/digital-product/resources/types/digital-resource-interface'
import React, { FC } from 'react'
import { DigitalProductErrorInterface } from '../../types/digital-product-interface'

interface Props {
  resources: DigitalResourceType[]
  errors: DigitalProductErrorInterface['resources']
}

export const ResourcesReadOnly: FC<Props> = ({ resources, errors }) => {
  const existingResourcesData = useDigitalResourceContent(resources, undefined, errors)

  return <ResourcesBase>{existingResourcesData}</ResourcesBase>
}
